exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".field[data-v-06c4a2ce]{margin-top:14px;margin-bottom:10px}.mt-button[data-v-06c4a2ce]{margin-top:10px}.mt-cell[data-v-06c4a2ce]{border-bottom:1px solid #dee2e6;margin-bottom:8px}", "", {"version":3,"sources":["F:/1.前端/ykb-weixin/src/views/medical-card/management-medical-card.vue"],"names":[],"mappings":"AACA,wBACE,gBAAiB,AACjB,kBAAoB,CACrB,AACD,4BACE,eAAiB,CAClB,AACD,0BACE,gCAAiC,AACjC,iBAAmB,CACpB","file":"management-medical-card.vue","sourcesContent":["\n.field[data-v-06c4a2ce] {\n  margin-top: 14px;\n  margin-bottom: 10px;\n}\n.mt-button[data-v-06c4a2ce] {\n  margin-top: 10px;\n}\n.mt-cell[data-v-06c4a2ce] {\n  border-bottom: 1px solid #dee2e6;\n  margin-bottom: 8px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-06c4a2ce","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/medical-card/management-medical-card.vue
// module id = 434
// module chunks = 44